/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  PromptTemplate,
  PromptTemplate$inboundSchema,
} from "./prompttemplate.js";

export type GetPromptTemplateResult = {
  /**
   * A prompt template
   */
  template: PromptTemplate;
};

/** @internal */
export const GetPromptTemplateResult$inboundSchema: z.ZodMiniType<
  GetPromptTemplateResult,
  unknown
> = z.object({
  template: PromptTemplate$inboundSchema,
});

export function getPromptTemplateResultFromJSON(
  jsonString: string,
): SafeParseResult<GetPromptTemplateResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetPromptTemplateResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetPromptTemplateResult' from JSON`,
  );
}
